import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  invokeEvent = new EventEmitter<any>();
  invokeLoginEvent = new EventEmitter<any>();

  constructor() {}

  triggerEvent(data: any) {
    this.invokeEvent.emit(data);
  }
  triggerLoginEvent(data: any) {
    this.invokeLoginEvent.emit(data);
  }
}
